import { DefaultOptionType } from "antd/es/select";
import uniqBy from "lodash/uniqBy";
import timezones from "timezones.json";
import { format, utcToZonedTime } from "date-fns-tz";

export const timezoneOptions: DefaultOptionType[] = uniqBy(
  timezones.flatMap(({ text, utc }) =>
    utc.map((value) => ({ value, label: `${text} ${value}` }))
  ),
  "value"
).map(({ value, label }) => {
  const now = new Date();

  const zonedTime = utcToZonedTime(now, value);

  const utcOffset = format(zonedTime, "zzz", { timeZone: value });

  const labelWithoutUTC = label
    // .replace(/\(.*?\)\s*/, "")
    .replace(/etc\/gmt(?:[+-]\d+)?/i, "")
    .trim();

  const newLabel = `(${utcOffset}) ${labelWithoutUTC}`;

  return { value, label: newLabel };
});
